const UserTypeStandard = 'standard'
const UserTypeTeacher = 'teacher'
const UserTypeStudent = 'student'
const UserTypeJudge = 'judge'
const UserTypeMentor = 'mentor'
const UserTypeJacAdmin = 'JACAdmin'

const UserTypes = [UserTypeStandard, UserTypeTeacher, UserTypeStudent, UserTypeJudge, UserTypeMentor, UserTypeJacAdmin]

export default {
  data: function () {
    return {
      UserTypeStandard,
      UserTypeTeacher,
      UserTypeStudent,
      UserTypeJudge,
      UserTypes,
      UserTypeMentor,
      UserTypeJacAdmin
    }
  }
}
